import React, { useRef, useState } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'

const CONTACT_EMAIL = 'Ayabelal.nutritionist@gmail.com'
const FORMSUBMIT_AJAX_URL = `https://formsubmit.co/ajax/${encodeURIComponent(CONTACT_EMAIL)}`

const Contact = () => {
    const sendingRef = useRef(false)
    const [formKey, setFormKey] = useState(0)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (sendingRef.current) return
        sendingRef.current = true

        const form = e.currentTarget
        const name = form.name.value.trim()
        const email = form.email.value.trim()
        const phone = form.phone.value.trim()
        const message = form.message.value.trim()

        try {
            const res = await fetch(FORMSUBMIT_AJAX_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    _subject: 'New message from your website contact form',
                    name,
                    email,
                    phone,
                    message,
                }),
            })

            if (!res.ok) {
                const errBody = await res.json().catch(() => ({}))
                throw new Error(errBody.error || errBody.message || 'Something went wrong. Please try again.')
            }

            form.reset()
            setFormKey((k) => k + 1)
            window.alert('Thank you! Your message has been sent.')
        } catch (err) {
            window.alert(err.message || 'Could not send your message. Please try again or email us directly.')
        } finally {
            sendingRef.current = false
        }
    }

    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <h1 className='medium font__size--72 text__70-1024 text__70-md text__70-sm text__70-xxs'>Let's get <span className='normal'>in touch!</span></h1>
                    <p className='normal font__size--16 text__16-1024 color__gray-2 mb-3 col-lg-7 ' style={{ paddingLeft: "0px" }}>Every time I witness a client’s life changing — their energy coming back, their confidence
                    growing — it reminds me exactly why I started this journey.</p>

                    <div className="row">
                        <div className="col-lg-8 mb-5 mb-lg-0">
                            <form key={formKey} onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="contact-name" className="medium font__size--14 text__14-1024 color__black w-100">Full Name</label>
                                    <input
                                        id="contact-name"
                                        name="name"
                                        type="text"
                                        autoComplete="name"
                                        required
                                        className="medium font__size--16 text__16-1024 text__16-1024 color__gray-2 form-control wrapper__input-field"
                                        placeholder="What’s your Name?"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="contact-email" className="medium font__size--14 text__14-1024 color__black w-100">Email</label>
                                    <input
                                        id="contact-email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        className="medium font__size--16 text__16-1024 text__16-1024 color__gray-2 form-control wrapper__input-field"
                                        placeholder="What’s your Email?"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="contact-phone" className="medium font__size--14 text__14-1024 color__black w-100">Phone</label>
                                    <input
                                        id="contact-phone"
                                        name="phone"
                                        type="tel"
                                        autoComplete="tel"
                                        className="medium font__size--16 text__16-1024 text__16-1024 color__gray-2 form-control wrapper__input-field"
                                        placeholder="What’s your Phone?"
                                    />
                                </div>
                                <div className="form-group mb-4 mb-lg-5">
                                    <label htmlFor="contact-message" className="medium font__size--14 text__14-1024 color__black w-100">Message</label>
                                    <textarea
                                        id="contact-message"
                                        name="message"
                                        className="medium font__size--16 text__16-1024 text__16-1024 color__gray-2 form-control wrapper__input-field textarea"
                                        placeholder="Write your message..."
                                        cols="30"
                                        rows="8"
                                        required
                                    />
                                </div>
                                <div className="text-right">
                                    <button type="submit" className='btn btn__purple shadow rounded__50 color__white d-inline-block medium text__16-1024'>
                                        Send Message
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-4">
                            <div className="wrapper__card-detail-program">
                                <h4 className='semi-bold font__size--18 text__18-1024 mb-2'>Contact Details</h4>
                                <p className='normal font__size--16 text__16-1024 color__gray-2 mb-4'>Fill up the form and our team will get back to you with in 24 hours.</p>


                                <div className="d-flex mb-3 align-items-center">
                                    <img src="./../images/ic (1).png" alt="" />
                                    <div className='ml-2 medium font__size--16 text__16-1024 color__black'>
                                    01011918162
                                    </div>
                                </div>
                                <div className="d-flex mb-3 align-items-center">
                                    <img src="./../images/ic (3).png" alt="" />
                                    <div className='ml-2 medium font__size--16 text__16-1024 color__black'>
                                        Ayabelal.nutritionist@gmail.com
                                    </div>
                                </div>
                                <h4 className='semi-bold font__size--18 text__18-1024 mb-2'>How to pay?</h4>
                                <p className='normal font__size--16 text__16-1024 color__gray-2 mb-4'>
  You can pay via Instapay or Vodafoncash just transfer to
  <a href="mailto:Aya@instapay" className="highlight mx-1">ayabelal36@instapay</a>
  after that attach a photo of transfer to
  <a href="https://wa.me/201011918162" target="_blank" rel="noopener noreferrer" className="highlight mx-1">201011918162</a>
  and your chosen plan and you will be contacted as soon as possible to confirm everything.
</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    )
}

export default Contact
